<template>
<div class="search-widget">
  <form method="get" :action="themeData.base.pageUrls.search">
    <input type="text" name="q" />
    <button>Pretraga</button>
  </form>
</div>
</template>

<script>
import SearchWidget from './SearchWidget.js';
export default SearchWidget;
</script>
